<template>
    <v-card
      color="white"
      class="overflow-y-auto list_box filtered_list_styles"
      :style="{padding: '24px', paddingTop: '0 !important'}"
    >

    <template v-if="Object.keys(filteredList).length > 0">
      <template v-for="(month, i) in Object.keys(filteredList)">
        <v-sheet
          :key="'A' + i * 123454"
          tile
          height="54"
          class="d-flex"
          justify="center"
          :style="{marginTop: '3rem'}"
          >
          <v-spacer></v-spacer>
          <h3 :style="{color: 'white', margin: '0.4rem'}"> {{ getMonthCapitalized(month) }} </h3>
          <v-spacer></v-spacer>
        </v-sheet>
        <template v-for="(day, i) in Object.keys(filteredList[month])">
          <template v-if="isToday(day)">
            <h3 id="today" :style="{marginBottom: '15px', marginTop: '45px'}"
            :key="'B' + i*23234520">
              {{ getDay(day) }}
            </h3>
          </template>
          <template v-else>
            <h3 :style="{marginBottom: '15px', marginTop: '45px'}" :key="'C' + i*234520 + day">
              {{ getDay(day) }}
            </h3>
          </template>
          <template v-if="Object.keys(filteredList[month][day]).length !== 0">
            <div v-for="notice in filteredList[month][day]" :key="'D' + notice.REF_NUM">
              <NoticeComponent :data=notice>
              </NoticeComponent>
            </div>
          </template>
          <template v-else>
            <p class="emptyDay" :key="'E' + day + i*23234520">
              {{ $t('views.pulsoDigital.empty') }}
            </p>
          </template>
        </template>
      </template>
    </template>
    <template v-else>
      <p :style="{marginTop: '2.5rem'}"> No hay eventos </p>
    </template>
  </v-card>
</template>

<script>
import NoticeComponent from '@/components/NoticeComponent.vue';

export default {
  components: {
    NoticeComponent,
  },
  props: {
    items: {
      type: Object,
    },
    filters: {
      type: Object,
    },
    ambitoFilters: {
      type: Function,
    },
  },
  data() {
    return {
      filteredList: {},
      weekDayES: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    };
  },
  computed: {
    paradaCategory() {
      return process.env.VUE_APP_PULSO_DIGITAL_CATEGORY_PARADA_PLANIFICADA;
    },
  },
  watch: {
    filters() {
      this.groupItemsByMonth();
    },
    items() {
      this.groupItemsByMonth();
    },
  },
  methods: {
    groupItemsByMonth() {
      const itemsGroupdByMonth = {};

      const ambitoFilteredList = this.ambitoFilters(this.items);

      Object.keys(ambitoFilteredList).forEach((fecha) => {
        const mes = this.getMonth(fecha);
        const filteredItems = this.getFilteredItems(ambitoFilteredList[fecha]);
        if (filteredItems.length > 0) {
          const day = {};
          day[fecha] = filteredItems;
          if (itemsGroupdByMonth[mes]) {
            itemsGroupdByMonth[mes] = {
              ...itemsGroupdByMonth[mes],
              ...day,
            };
          } else {
            itemsGroupdByMonth[mes] = {};
            itemsGroupdByMonth[mes] = {
              ...day,
            };
          }
        }
      });

      // se añade el día de hoy si no existe en el listado
      const today = new Date();
      const auxTodayMonth = `${today.getMonth() + 1}/${today.getFullYear()}`;
      const todayAux = `${today.getDate().toString().padStart(2, '0')}/${(today.getMonth() + 1).toString().padStart(2, '0')}/${today.getFullYear()}`;

      const auxToday = {};
      if (!Object.keys(itemsGroupdByMonth).includes(auxTodayMonth)) {
        auxToday[todayAux] = {};
        itemsGroupdByMonth[auxTodayMonth] = {};
        itemsGroupdByMonth[auxTodayMonth] = {
          ...auxToday,
        };
      }

      const mes = itemsGroupdByMonth[auxTodayMonth];
      if (!Object.keys(mes).includes(todayAux)) {
        itemsGroupdByMonth[auxTodayMonth][todayAux] = {};
        itemsGroupdByMonth[auxTodayMonth][todayAux] = {
          ...itemsGroupdByMonth[auxTodayMonth][todayAux],
          ...auxToday,
        };
      }

      this.filteredList = this.sortList(itemsGroupdByMonth);
      this.focusToday();
    },
    getMonth(dateStr) {
      const splittedDate = dateStr.split('/');
      const formalDate = `${splittedDate[1]}/${splittedDate[0]}/${splittedDate[2]}`;
      const date = new Date(formalDate);
      return `${date.getMonth() + 1}/${date.getFullYear()}`;
    },
    getFilteredItems(items) {
      const res = items.filter((item) => {
        // Se comprueban los tipos
        let matchType = false;
        if (this.filters.type.some((type) => type.value === 'all')) {
          matchType = true;
        } else {
          matchType = this.filters.type.some((type) => type.value === item.type);
        }

        // Se comprueban los estados
        const matchStatus = this.filters.status.some((estado) => estado.value === item.status);

        return matchType && matchStatus;
      });

      return res;
    },
    getMonthCapitalized(monthStr) {
      const splitDate = monthStr.split('/');
      const fecha = new Date(`${splitDate[0]}/01/${splitDate[1]}`);
      const month = fecha.toLocaleString('es-ES', { month: 'long' });
      const res = month.charAt(0).toUpperCase() + month.slice(1);
      if (Number(splitDate[1]) !== new Date().getFullYear()) {
        return `${res} ${splitDate[1]}`;
      }
      return res;
    },
    getDay(dateStr) {
      const dateSplit = dateStr.split('/');
      const fecha = new Date(`${dateSplit[1]}/${dateSplit[0]}/${dateSplit[2]}`);
      return `${this.weekDayES[fecha.getDay()]} ${dateSplit[0]}`;
    },
    sortList(items) {
      const keys = Object.keys(items);
      const sortedKeys = keys.sort((a, b) => {
        let [monthA, yearA] = a.split('/');// eslint-disable-line
        let [monthB, yearB] = b.split('/');// eslint-disable-line

        yearA = parseInt(yearA);// eslint-disable-line
        yearB = parseInt(yearB);// eslint-disable-line

        if (yearA !== yearB) {
          return yearA - yearB;
        }

        return parseInt(monthA) - parseInt(monthB);// eslint-disable-line
      });

      const sortedList = {};

      sortedKeys.forEach((key) => {
        const data = items[key];
        const sortedDataKeys = Object.keys(data).sort((a, b) => {
        let [dayA] = a.split('/');// eslint-disable-line
        let [dayB] = b.split('/');// eslint-disable-line

        dayA = parseInt(dayA);// eslint-disable-line
        dayB = parseInt(dayB);// eslint-disable-line

        return parseInt(dayA) - parseInt(dayB);// eslint-disable-line
        });

        const sortedData = {};

        sortedDataKeys.forEach((dataKey) => {
          sortedData[dataKey] = {
            ...sortedData[dataKey],
            ...items[key][dataKey],
          };
        });

        sortedList[key] = {
          ...sortedList[key],
          ...sortedData,
        };
      });
      return sortedList;
    },
    isToday(dateStr) {
      const dateSplit = dateStr.split('/');
      const auxToday = new Date(`${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`);
      const auxDateToday = new Date();

      auxToday.setHours(0, 0, 0, 0);
      auxDateToday.setHours(0, 0, 0, 0);

      return auxToday.getTime() === auxDateToday.getTime();
    },
    focusToday() {
      const elem = document.getElementById('today');
      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  mounted() {
    this.focusToday();
  },
  created() {
    this.groupItemsByMonth();
  },
};
</script>

<style>

  .filtered_list_styles {
    margin-top: 13rem !important;
  }

  @media screen and (max-width: 790px) {
    .filtered_list_styles {
      margin-top: 14rem !important;
    }
  }

  #today {
    color: #27846d;
  }

  .emptyDay {
    margin-left: 1.3rem;
  }
</style>
